import { c as _c } from "react/compiler-runtime";
import { CloseButton as HeadlessCloseButton } from '@headlessui/react';
import classNames from '@/utils/classNames';
import CloseIcon from '@/icons/CloseIcon';
import { buttonNavigationVariants } from '../Button/Button.navigation.variants';
import type { ModalCloseButtonProps } from './Modal.types';
const CloseButton = t0 => {
  const $ = _c(11);
  let as;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      as,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = as;
    $[2] = className;
    $[3] = props;
  } else {
    as = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = classNames(buttonNavigationVariants({
      variant: "outline",
      color: "secondary",
      size: "small"
    }), "absolute", "right-8", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CloseIcon />;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== as || $[8] !== props || $[9] !== t1) {
    t3 = <HeadlessCloseButton type="button" as={as} className={t1} data-testid="modal-close-button" {...props}>{t2}</HeadlessCloseButton>;
    $[7] = as;
    $[8] = props;
    $[9] = t1;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
export default CloseButton;